import * as React from 'react';

interface IProps {
    className?: string;
}

class IconEllipseBottomLeft extends React.Component<IProps> {
    public render() {
        return (
            <svg viewBox="0 0 86 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
                <mask id="path-1-inside-1" fill="white">
                    <path d="M0.644653 14.6447C8.22963 7.05969 18.0528 2.11511 28.6635 0.541173C39.2742 -1.03276 50.1097 0.8474 59.5699 5.90398C69.0301 10.9606 76.6132 18.9255 81.1995 28.6224C85.7858 38.3193 87.132 49.234 85.0392 59.7547L67.7284 56.3113C69.0824 49.5044 68.2114 42.4426 65.2441 36.1687C62.2768 29.8948 57.3705 24.7415 51.2497 21.4699C45.129 18.1983 38.1184 16.9818 31.2533 18.0001C24.3882 19.0185 18.0326 22.2176 13.1251 27.1251L0.644653 14.6447Z" />
                </mask>
                <path
                    d="M0.644653 14.6447C8.22963 7.05969 18.0528 2.11511 28.6635 0.541173C39.2742 -1.03276 50.1097 0.8474 59.5699 5.90398C69.0301 10.9606 76.6132 18.9255 81.1995 28.6224C85.7858 38.3193 87.132 49.234 85.0392 59.7547L67.7284 56.3113C69.0824 49.5044 68.2114 42.4426 65.2441 36.1687C62.2768 29.8948 57.3705 24.7415 51.2497 21.4699C45.129 18.1983 38.1184 16.9818 31.2533 18.0001C24.3882 19.0185 18.0326 22.2176 13.1251 27.1251L0.644653 14.6447Z"
                    stroke="#039BE5"
                    strokeWidth="52"
                    mask="url(#path-1-inside-1)"
                />
            </svg>
        );
    }
}

export default IconEllipseBottomLeft;
